"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  firstName: null,
  lastName: null,
  phoneNumber: null,
  workNumber: null,
  linkedInUrl: null,
  officeLocation: null,
  department: null,
  jobTitle: null,
  imageUrl: null,
  organisationId: null,
  initialSetup: null
};
exports.default = _default;